import {
    emitAccessKeyAssignSub,
    emitAccessKeyParkerAssignReq,
    emitAccessKeyReq,
    emitAccessKeyVehicleSubAssignReq,
    emitChangeEmailReq,
    emitChangeNameReq,
    emitChangePasswordReq,
    emitCheckCreateReq,
    emitFacilityCreateReq,
    emitFacilityUpdateReq,
    emitForgotPasswordReq,
    emitImportPaymentReq,
    emitInviteParkerReq,
    emitInviteStaffReq,
    emitLogInReq,
    emitOrderAdjustReq,
    emitOrderCustomReq,
    emitPaymentAdjustReq,
    emitPlanCreateReq,
    emitPlanInvoiceReq,
    emitPlanPriceAddReq,
    emitPlanUpdateReq,
    emitRateProgramData,
    emitResetCodeCheckReq,
    emitResetPasswordReq,
    emitStaffNotificationUpdateReq,
    emitStaffUpdateReq,
    emitSubscriptionUpdateReq
} from "./ApiEmit";
import {
    parseAccessKey,
    parseBalanceChange,
    parseFacility,
    parseFacilityLite,
    parseFacilityInvoice,
    parseFacilityPayment,
    parseFacilityPayout,
    parseFacilityStats,
    parseFacilitySub,
    parseFacilitySubByParker,
    parseInvoice,
    parseOperator,
    parseOrder,
    parseOrderBalance,
    parseOrderDebt,
    parseOrderDetails,
    parseParkerAgingRecord,
    parseParkerDetails,
    parseParkerDetailsGridResult,
    parseParkerInfo,
    parsePayment,
    parsePaymentChange,
    parsePlan,
    parsePlanDetails,
    parsePlanInvoiceResp,
    parsePlanPriceListResp,
    parseRateProgram,
    parseSearchResult,
    parseSession,
    parseStaff,
    parseStaffNotification,
    parseStripeLinkResp,
    parseSubEntry,
    parseSubEntryForEdit,
    parseSubscription,
    parseVehicle,
    parseVehicleDetails,
    parseVehicleLinkResp,
    parseRateProgramDropdown} from "./ApiParse";
import {
    StaffApi,
    SubscriptionApi,
    SubscriptionParkerApi,
    SubscriptionParkerChangeReqApi,
    SubscriptionParkerInviteReqApi,
    SubscriptionParkerRemoveReqApi,
    SubscriptionStatus,
    VehicleAddReqApi,
    VehicleDeleteReqApi,
} from "./ApiTransport";
import {
    AccessKeyAssignSub,
    AccessKeyParkerAssignReq,
    AccessKeyReq,
    AccessKeyVehicleSubAssignReq,
    ChangeNameReq,
    CheckCreateReq,
    FacilityCreateReq,
    FacilityUpdateReq,
    ImportPaymentReq,
    InviteParkerReq,
    InviteStaffReq,
    OrderAdjustReq,
    OrderCustomReq,
    ParkerAgingRecord,
    ParkerImportReq,
    ParkerUpdateReq,
    PaymentAdjustReq,
    PlanCreateReq,
    PlanInvoiceReq,
    PlanPriceAddReq,
    PlanUpdateReq,
    RateProgramData,
    ResetCodeCheckReq,
    ResetPasswordReq,
    StaffNotificationUpdateReq,
    StaffUpdateReq,
    SubscriptionUpdateReq,
    Vehicle
} from "./ApiTypes";
import { ApiUrl } from "./ApiUrl";
import {
    OkResult,
    Result
} from "./Result";
import { PaymentReport, PagedResult, PayoutSummaryReportApiResponse, SubscriptionReport } from "./ApiTypes";
import { checkExpiration } from "../shared/apiConfig";
import { beginGlobalLoadingMask, endGlobalLoadingMask } from "./Atoms";
import { clearLocalStoragePreserving, STORAGE_GROUPS } from "../shared/localStorageHelper";
import { Instant } from "@js-joda/core";

const arr = <TValApi, TVal>(func: (api: TValApi) => TVal) => (x: TValApi[]) => x.map(func);

// Local function for identity transformation
function identityTransform<T>(x: T): T { return x; }

export interface PaymentReportFilter {
    parkerId?: number;
    operatorId?: number;
    facilityId?: number;
    facilityIds?: number[];
    from?: string;
    to?: string;
    payoutFrom?: string;
    payoutTo?: string;
    paymentType?: string;
    paymentStatus?: string;
    email?: string;
    name?: string;
}

export interface PayoutSummaryReportFilter {
    operatorId?: number;
    from?: string;
    to?: string;
}

export interface SubscriptionReportFilter {
    parkerId?: number;
    operatorId?: number;
    facilityId?: number;
    from?: string;
    to?: string;
    planName?: string;
    email?: string;
    name?: string;
    status?: string;
    expireDate?: string;
}

export interface AgingReportFilter {
    facilityId?: number;
    email?: string;
    name?: string;
    age?: string;
    cutoffDate?: string;
}

export const notSet = (a: any) => a === null;

export interface LogInReq {
    emailAddress: string;
    password: string;
}

export interface SignUpReq {
    emailAddress: string;
    name: string;
    password: string;
    passwordConfirm: string;
}

export interface ChgPassReq {
    currentPassword: string;
    newPassword: string;
}

export interface ChgEmailAddressReq {
    currentPassword: string;
    newEmailAddress: string;
}

export interface ConnectInitResp {
    clientSecret: string;
}

export type LogInResp = StaffApi;
export type ChgPassResp = StaffApi;
export type ChgEmailResp = StaffApi;
export type ResetPassResp = StaffApi;
export type ResetCodeCheckResp = StaffApi;

export interface ForgotPassReq { emailAddress: string; }
export type ForgotPassResp = string;

export const showRole = (r: number) => {
    if (r === 0) { return "Site Admin"; }
    if (r === 1) { return "Operator Admin"; }
    return "Err!";
}

const get = (): RequestInit => {
    const subdomain = window.location.hostname.split('.')[0];
    return {
        method: "GET",
        credentials: "include",
        headers: { "X-Customer-Subdomain": subdomain }
    }
}

const json = (verb: string, payload: any): RequestInit => {
    const subdomain = window.location.hostname.split('.')[0];
    return {
        method: verb,
        headers: {
            "Content-Type": "application/json",
            "X-Customer-Subdomain": subdomain
        },
        body: JSON.stringify(payload),
        credentials: "include"
    }
}

const jsonDelete = () => json("DELETE", {});
const post = (payload: any) => json("POST", payload);
const resOk = <T>(value: T): OkResult<T> => ({ isOk: true, value: value })
const ok = <T>(value: T): Promise<OkResult<T>> => Promise.resolve(resOk(value));
const okDelay = <TErr, TVal>(value: TVal): Promise<Result<TErr, TVal>> =>
    new Promise((resolve) => setTimeout(() => { resolve(resOk(value)); }, 500)
    );



// Function to refresh the access token using the refresh token.
const refreshAuthToken = async (refreshToken): Promise<string | null> => {

    try {
        const response = await fetch(`${import.meta.env.VITE_SPOT_SYNC_SERVICES}/auth/refresh`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ refreshToken })
        });

        const data = await response.json();

        if (response.ok && data.accessToken) {
            // Update tokens in localStorage
            localStorage.setItem("authToken", JSON.stringify({ accessToken: data.accessToken }));
            if (data.refreshToken) {
                localStorage.setItem("refreshToken", JSON.stringify(data.refreshToken));
            }
            return data.accessToken;
        } else {
            throw new Error("Refresh token failed");
        }
    } catch (error) {
        console.error("Token refresh error:", error);
        return null;
    }
};
export const api = <TVal>(url: string, init: RequestInit = {}): Promise<Result<string, TVal>> => {
     // begin global mask
     beginGlobalLoadingMask();
    // Parse token if it exists in localStorage
    const accessToken = (() => {
        try {
            const authTokenStr = localStorage.getItem("authToken");
            if (authTokenStr) {
                const authToken = JSON.parse(authTokenStr);
                if (checkExpiration(authToken.accessToken)) {
                    return null; // Token expired
                }
                return authToken.accessToken;
            }
            return null;
        } catch {
            endGlobalLoadingMask();
            localStorage.clear();
            window.location.href = '/login';
            return null;
        }
    })();


    // Merge headers from init (could be Headers object or plain object)
    let baseHeaders: Record<string, string> = {};
    if (init.headers) {
        if (init.headers instanceof Headers) {
            // Convert Headers to object
            (init.headers as Headers).forEach((value, key) => {
                baseHeaders[key] = value;
            });
        } else {
            baseHeaders = { ...init.headers as Record<string, string> };
        }
    }
    // If access token is expired or missing, attempt to refresh it
    if (!accessToken) {
        return refreshAuthToken(accessToken).then(newToken => {
            if (newToken) {
                // Retry the request with the new token
                baseHeaders['Authorization'] = `Bearer ${newToken}`;
                return fetch(url, { ...init, headers: baseHeaders }).then(response => {
                    const json = response.json();
                    if (response.status === 401) {
                        window.location.href = '/login';
                    }
                    const isOk = response.status === 200;
                    return json.then(data => {
                        if (isOk) {
                            return { isOk: true, value: data };
                        }
                        return { isOk: false, error: data };
                    });
                });
            } else {
                clearLocalStoragePreserving([STORAGE_GROUPS.reporting]);
                window.location.href = '/login';
                return Promise.reject('Token refresh failed, redirecting to login');
            }
        });
    }

    // Add Authorization if token is present
    if (accessToken) {
        baseHeaders['Authorization'] = `Bearer ${accessToken}`;
    }
    return fetch(url, {
        ...init,
        headers: baseHeaders,
    })
        .then(response => {
            const json = response.json();
            if (response.status == 401) {
                window.location.href = '/login'
            }
            const isOk = (response.status == 200);
            return json.then(data => {
                endGlobalLoadingMask();
                if (isOk) {
                    return { isOk: true, value: data };
                }
                return { isOk: false, error: data }
            });
        });
}

const api2 = <TValApi, TVal>(url: string, init: RequestInit = {}, f: (x: TValApi) => TVal, allowAnonymous = false, silent = false): Promise<Result<string, TVal>> => {
    if( !silent ) beginGlobalLoadingMask();
    // Parse token if it exists in localStorage
    const accessToken = (() => {
        try {
            const authTokenStr = localStorage.getItem("authToken");
            if (authTokenStr) {
                const authToken = JSON.parse(authTokenStr!);
                if (checkExpiration(authToken.accessToken)) throw new Error("Token expired");
                return authToken.accessToken;
            }
            return null;
        } catch {
            clearLocalStoragePreserving([STORAGE_GROUPS.reporting]);
            window.location.href = '/login';
        }
    })();

    // Merge headers from init (could be Headers object or plain object)
    let baseHeaders: Record<string, string> = {};
    if (init.headers) {
        if (init.headers instanceof Headers) {
            // Convert Headers to object
            (init.headers as Headers).forEach((value, key) => {
                baseHeaders[key] = value;
            });
        } else {
            baseHeaders = { ...init.headers as Record<string, string> };
        }
    }
    // If access token is expired or missing, attempt to refresh it
    if (!accessToken && !allowAnonymous) {
        return refreshAuthToken(accessToken).then(newToken => {
            if (newToken) {
                // Retry the request with the new token
                baseHeaders['Authorization'] = `Bearer ${newToken}`;
                return fetch(url, { ...init, headers: baseHeaders }).then(response => {
                    const json = response.json();
                    if (response.status === 401) {
                        window.location.href = '/login';
                    }
                    const isOk = response.status === 200;
                    return json.then(data => {
                        if (isOk) {
                            const parsed = f(data);
                            return { isOk: true, value: parsed };
                        }
                        return { isOk: false, error: data };
                    });
                });
            } else {
                clearLocalStoragePreserving([STORAGE_GROUPS.reporting, STORAGE_GROUPS.redirect]);
                window.location.href = '/login';
                return Promise.reject('Token refresh failed, redirecting to login');
            }
        });
    }


    // Add Authorization if token is present
    if (accessToken) {
        baseHeaders['Authorization'] = `Bearer ${accessToken}`;
    }
    return fetch(url, {
        ...init,
        headers: baseHeaders,
    })

        .then(response => {
            const json = response.json();
            if (response.status == 401) {
                window.location.href = '/login'
            }
            const isOk = (response.status == 200);
            return json.then(data => {
                if( !silent ) endGlobalLoadingMask();
                if (isOk) {
                    const parsed = f(data);
                    return { isOk: true, value: parsed };
                }
                return { isOk: false, error: data }
            });
        });
}

export function identity<T>(arg: T) { return arg; }
export function unknown<T>(arg: T) { return undefined; }

function parseString(x: string): string { return x };

export class Api {

    //auth stuff    
    static amILoggedIn = () => api2(ApiUrl.amILoggedIn(), get(), parseStaff);
    static logIn = (req: LogInReq) => api2(ApiUrl.logIn(), post(emitLogInReq(req)), parseStaff);
    static logOut = () => api2(ApiUrl.logOut(), post({}), parseStaff);
    static forgotPassword = (req: ForgotPassReq) => api2(ApiUrl.forgotPassword(), post(emitForgotPasswordReq(req)), parseString, true);
    static resetCodeCheck = (req: ResetCodeCheckReq) => api2(ApiUrl.resetCodeCheck(), post(emitResetCodeCheckReq(req)), parseStaff, true);
    static resetPassword = (req: ResetPasswordReq) => api2(ApiUrl.resetPassword(), post(emitResetPasswordReq(req)), parseStaff, true);
    static changeEmailAddress = (req: ChgEmailAddressReq) => api2(ApiUrl.changeEmailAddress(), post(emitChangeEmailReq(req)), parseStaff);
    static changeName = (req: ChangeNameReq) => api2(ApiUrl.changeName(), post(emitChangeNameReq(req)), parseStaff);
    static changeParkerName = (parkerId: number, req: ChangeNameReq) => api2(ApiUrl.changeParkerName(parkerId), post(emitChangeNameReq(req)), parseParkerInfo);
    static changePassword = (req: ChgPassReq) => api2(ApiUrl.changePassword(), post(emitChangePasswordReq(req)), parseStaff);

    //staff
    static staffInvite = (req: InviteStaffReq) => api2(ApiUrl.staffInvite(), post(emitInviteStaffReq(req)), parseStaff);
    static staffList = () => api2(ApiUrl.staffList(), get(), arr(parseStaff));
    static staffGet = (staffId: number) => api2(ApiUrl.staffGet(staffId), get(), parseStaff);
    static staffUpdate = (staffId: number, req: StaffUpdateReq) => api2(ApiUrl.staffUpdate(staffId), post(emitStaffUpdateReq(req)), parseStaff);
    static staffDisable = (staffId: number) => api2(ApiUrl.staffDisable(staffId), post({}), parseStaff);
    static staffEnable = (staffId: number) => api2(ApiUrl.staffEnable(staffId), post({}), parseStaff);

    //staff notifications
    static staffNotificationsList = () => api2(ApiUrl.staffNotifications(), get(), arr(parseStaffNotification));
    static changeStaffNotification = (req: StaffNotificationUpdateReq) => api2(ApiUrl.changeStaffNotification(), post(emitStaffNotificationUpdateReq(req)), parseStaffNotification);

    //facilities 
    static facilityCreate = (req: FacilityCreateReq) => api2(ApiUrl.facilityCreate(), post(emitFacilityCreateReq(req)), parseString);
    static facilityUpdate = (req: FacilityUpdateReq) => api2(ApiUrl.facilityUpdate(req.facilityId), post(emitFacilityUpdateReq(req)), parseString);
    static facilityList = () => api2(ApiUrl.facilityList(), get(), arr(parseFacilityLite));
    static facilityDetails = (facilityId: number) => api2(ApiUrl.facilityDetails(facilityId), get(), parseFacility);
    static facilityStatsGet = (facilityId: number) => api2(ApiUrl.facilityStatsGet(facilityId), get(), parseFacilityStats);
    static facilityPaymentList = (facilityId: number) => api2(ApiUrl.facilityPaymentList(facilityId), get(), arr(parseFacilityPayment));

    static facilitySearch = (facilityId: number, query: string) =>
        api2(ApiUrl.facilitySearch(facilityId, query), get(), arr(parseSearchResult));

    static facilityParkerList = (facilityId: number) =>
        api2(ApiUrl.facilityParkerList(facilityId), get(), parseParkerDetailsGridResult);

    static facilitySessionList = ( facilityId: number, opts?: { timeZone?: string; createdSince?: Instant; silent?: boolean } ) =>
        api2(
            ApiUrl.facilitySessionList( facilityId, {
                timeZone: opts?.timeZone,
                createdSince: opts?.createdSince?.toString(),
            } ),
            get(),
            arr( parseSession ),
            false,
            opts?.silent ?? false
        );

    static facilitySubscriptionList = (facilityId: number) =>
        api2(ApiUrl.facilitySubscriptionList(facilityId), get(), arr(parseFacilitySub));

    static facilitySubscriptionListByParker = (facilityId: number, parkerId: number) =>
        api2(ApiUrl.facilitySubscriptionListByParker(facilityId, parkerId), get(), arr(parseFacilitySubByParker));

    static changeSubscriptionStatus(subscriptionId: number, status: SubscriptionStatus, isAccountsReceivable?: boolean, cancellationReason?: string) {
        const body = cancellationReason !== undefined ? { cancellationReason } : {};
        return api<SubscriptionStatus>(ApiUrl.changeSubscriptionStatus(subscriptionId, status, isAccountsReceivable), post(body));
    }

    static facilityParkerDetails = (facilityId: number, parkerId: number) =>
        api2(ApiUrl.facilityParkerDetails(facilityId, parkerId), get(), parseParkerDetails);

    static facilityParkerVehicleList = (facilityId: number, parkerId: number) =>
        api2(ApiUrl.facilityParkerVehicleList(facilityId, parkerId), get(), arr(parseVehicleDetails));

    static facilityCustomOrderCreate = (facId: number, req: OrderCustomReq) =>
        api2(ApiUrl.facilityCustomOrderCreate(facId), post(emitOrderCustomReq(req)), parseOrder);

    static facilityParkerInvite = (facilityId: number, req: InviteParkerReq) =>
        api2<string, string>(ApiUrl.facilityParkerInvite(facilityId), post(emitInviteParkerReq(req)), x => x);

    static facilityParkerInviteAction = (facilityId: number, parkerId: number, inviteId: number, action: string) =>
        api2<string, string>(ApiUrl.facilityParkerInviteAction(facilityId, parkerId, inviteId, action), get(), x => x);

    static facilitySubscriptionGet = (facilityId: number, subscriptionId: number) =>
        api2(ApiUrl.facilitySubscriptionGet(facilityId, subscriptionId), get(), parseSubscription);

    static subscriptionDetails(id: number) { return api<SubscriptionApi>(ApiUrl.subscriptionDetails(id), get()); }

    static subscriptionUpdateEnhanced(facId: number, subId: number) { return api<string>(ApiUrl.subscriptionUpdateEnhanced(facId, subId), post({})); }

    static facilitySubscriptionEditGet = (facilityId: number, subscriptionId: number) =>
        api2(ApiUrl.facilitySubscriptionEditGet(facilityId, subscriptionId), get(), parseSubEntryForEdit);

    static facilitySubscriptionEditUpdate = (facilityId: number, subscriptionId: number, req: SubscriptionUpdateReq) =>
        api2(ApiUrl.facilitySubscriptionEditUpdate(facilityId, subscriptionId), post(emitSubscriptionUpdateReq(req)), parseSubEntry);
    static parkerImport = (facId: number, req: ParkerImportReq) => {
        const formData = new FormData();
        formData.append("file", req.file);
        const subdomain = window.location.hostname.split('.')[0];

        return api2(ApiUrl.parkerImport(facId), {
            method: "POST",
            body: formData,
            headers: {
                "X-Customer-Subdomain": subdomain,
            },
        }, x => x);
    };

    //facility big lists
    static facilityInvoiceList = (facilityId: number) =>
        api2(ApiUrl.facilityInvoiceList(facilityId), get(), arr(parseFacilityInvoice));

    //plans
    static facilityPlanCreate = (facilityId: number, req: PlanCreateReq) =>
        api2(ApiUrl.facilityPlanCreate(facilityId), post(emitPlanCreateReq(req)), parsePlan);

    static facilityPlanList = (id: number) =>
        api2(ApiUrl.facilityPlanList(id), get(), arr(parsePlan));

    static facilityPlanGet = (facilityId: number, planId: number) =>
        api2(ApiUrl.facilityPlanGet(facilityId, planId), get(), parsePlanDetails);

    static facilityPlanUpdate = (facilityId: number, planId: number, req: PlanUpdateReq) =>
        api2(ApiUrl.facilityPlanUpdate(facilityId, planId), post(emitPlanUpdateReq(req)), parsePlan);

    //plan prices
    static facilityPlanPriceAdd = (facilityId: number, planId: number, req: PlanPriceAddReq) =>
        api2(ApiUrl.facilityPlanPriceCreate(facilityId, planId), post(emitPlanPriceAddReq(req)), parsePlanPriceListResp);

    static facilityPlanPriceList = (facilityId: number, planId: number) =>
        api2(ApiUrl.facilityPlanPriceList(facilityId, planId), get(), arr(parsePlanPriceListResp));

    static facilityPlanInvoiceInit = (facilityId: number, planId: number, req: PlanInvoiceReq) =>
        api2(ApiUrl.facilityPlanInvoiceInit(facilityId, planId), post(emitPlanInvoiceReq(req)), arr(parsePlanInvoiceResp));

    static facilityPlanInvoiceConfirm = (facilityId: number, planId: number, req: PlanInvoiceReq) =>
        api2(ApiUrl.facilityPlanInvoiceConfirm(facilityId, planId), post(emitPlanInvoiceReq(req)), arr(parsePlanInvoiceResp));

    //rates
    static facilityRateList = (facilityId: number) => api2(ApiUrl.facilityRateList(facilityId), get(), arr(parseRateProgram));
    static facilityRateGet = (facilityId: number, rateProgramId: number) => api2(ApiUrl.facilityRateGet(facilityId, rateProgramId), get(), parseRateProgram);
    static facilityRateGetDiscounts = (facilityId: number) => api2(ApiUrl.facilityRateGetDiscounts(facilityId), get(), parseRateProgramDropdown);
    static facilityRateCreate = (facilityId: number, req: RateProgramData) => api2(ApiUrl.facilityRateCreate(facilityId), post(emitRateProgramData(req)), parseRateProgram);
    static facilityRateUpdate = (facilityId: number, rateProgramId: number, req: RateProgramData) => api2(ApiUrl.facilityRateUpdate(facilityId, rateProgramId), post(emitRateProgramData(req)), parseRateProgram);
    static facilityRateStatusUpdate = (facilityId: number, rateProgramId: number, isActive: boolean) => api2(ApiUrl.facilityRateStatusUpdate(facilityId, rateProgramId, isActive), post({}), parseRateProgram);
    static facilityRatePreview = (facilityId: number, start: string, end: string) =>
        api<{ price: number; fees?: { amount: number; name: string }[] }>(ApiUrl.facilityRatePreview(facilityId), post({ start, end }));
    //parker
    static parkerUpdate(id: number, req: ParkerUpdateReq) { return api2(ApiUrl.parkerUpdate(id), post(req), parseParkerInfo); }

    //stripe
    static stripeInit(facilityId: number) { return api2<ConnectInitResp, ConnectInitResp>(ApiUrl.stripeInit(facilityId), post({}), identityTransform, true); }
    static stripeLink(facilityId: number, createAccount: boolean = true) { return api2(ApiUrl.stripeLink(facilityId, createAccount), get(), parseStripeLinkResp, true); }

    //operator
    static opDetails() { return api2(ApiUrl.opDetails(), get(), parseOperator, true); }

    //finance
    static orderList = (facilityId: number, parkerId: number) => api2(ApiUrl.facilityParkerOrderList(facilityId, parkerId), get(), arr(parseOrder));
    static orderOpenList = (facilityId: number, parkerId: number) => api2(ApiUrl.facilityParkerOrderOpenList(facilityId, parkerId), get(), arr(parseOrderDebt));
    static orderDetails = (facilityId: number, parkerId: number, orderId: number) => api2(ApiUrl.facilityParkerOrderDetails(facilityId, parkerId, orderId), get(), parseOrderDetails);

    static invoiceList = (facilityId: number, parkerId: number) => api2(ApiUrl.facilityParkerInvoiceList(facilityId, parkerId), get(), arr(parseInvoice));
    static invoiceDetails = (facilityId: number, parkerId: number, invoiceId: number) => api2(ApiUrl.facilityParkerInvoiceDetails(facilityId, parkerId, invoiceId), get(), parseInvoice);
    static reprintInvoice = (facilityId: number, parkerId: number, invoiceId: number, recipientEmail?: string, isAdjustmentReprint?: boolean) => api<unknown>(ApiUrl.facilityParkerInvoiceReprint(facilityId, parkerId, invoiceId, recipientEmail, isAdjustmentReprint), get());

    static balanceHistory = (facilityId: number, parkerId: number) => api2(ApiUrl.facilityParkerBalanceHistory(facilityId, parkerId), get(), arr(parseBalanceChange));
    static paymentList = (facilityId: number, parkerId: number) => api2(ApiUrl.facilityParkerPaymentList(facilityId, parkerId), get(), arr(parsePayment));
    static paymentDetails = (facilityId: number, parkerId: number, paymentId: number) => api2(ApiUrl.facilityParkerPaymentDetails(facilityId, parkerId, paymentId), get(), parsePayment);

    static facilityPayoutList = (facilityId: number) => api2(ApiUrl.facilityPayoutList(facilityId), get(), arr(parseFacilityPayout));
    static facilityPayoutDetails = (facilityId: number, payoutId: number) => api2(ApiUrl.facilityPayoutDetails(facilityId, payoutId), get(), parseFacilityPayout);

    //access keys
    static facilityAccessKeyList = (facilityId: number) =>
        api2(ApiUrl.facilityAccessKeyList(facilityId), get(), arr(parseAccessKey));

    static facilityAccessKeyGet = (facilityId: number, accessKeyId: number) =>
        api2(ApiUrl.facilityAccessKeyGet(facilityId, accessKeyId), get(), parseAccessKey);

    static facilityAccessKeyCreate = (facilityId: number, req: AccessKeyReq) =>
        api2(ApiUrl.facilityAccessKeyCreate(facilityId), post(emitAccessKeyReq(req)), parseAccessKey);

    static facilityAccessKeyUpdate = (facilityId: number, accessKeyId: number, req: AccessKeyReq) =>
        api2(ApiUrl.facilityAccessKeyUpdate(facilityId, accessKeyId), post(emitAccessKeyReq(req)), parseAccessKey);

    static facilityAccessKeyAssignSubscription = (facilityId: number, accessKeyId: number, req: AccessKeyAssignSub) =>
        api2(ApiUrl.facilityAccessKeyAssignSubscription(facilityId, accessKeyId), post(emitAccessKeyAssignSub(req)), parseAccessKey);

    static facilityAccessKeyAssignParker = (facilityId: number, accessKeyId: number, req: AccessKeyParkerAssignReq) =>
        api2(ApiUrl.facilityAccessKeyAssignParker(facilityId, accessKeyId), post(emitAccessKeyParkerAssignReq(req)), parseAccessKey);

    static facilityAccessKeyAssignVehicle = (facilityId: number, accessKeyId: number, req: AccessKeyVehicleSubAssignReq) =>
        api2(ApiUrl.facilityAccessKeyAssignVehicle(facilityId, accessKeyId), post(emitAccessKeyVehicleSubAssignReq(req)), parseAccessKey);

    static facilityAccessKeyRemove = (facilityId: number, accessKeyId: number, accessKeyLinkId: number) =>
        api2(ApiUrl.facilityAccessKeyRemove(facilityId, accessKeyId, accessKeyLinkId), post({}), parseString);

    static facilityAccessKeyLinkRemove = (facilityId: number, accessKeyId: number) =>
        api2(ApiUrl.facilityAccessKeyLinkRemove(facilityId, accessKeyId), post({}), parseAccessKey);

    static paymentAdjust = (facilityId: number, parkerId: number, req: PaymentAdjustReq) =>
        api2(ApiUrl.facilityParkerPaymentAdjust(facilityId, parkerId), post(emitPaymentAdjustReq(req)), parsePaymentChange);

    static orderAdjust = (facilityId: number, parkerId: number, req: OrderAdjustReq) =>
        api2(ApiUrl.facilityParkerOrderAdjust(facilityId, parkerId), post(emitOrderAdjustReq(req)), parseOrderBalance);

    static paymentCheckCreate = (facilityId: number, parkerId: number, req: CheckCreateReq) =>
        api2(ApiUrl.facilityParkerCheckCreate(facilityId, parkerId), post(emitCheckCreateReq(req)), parsePayment);

    static paymentImportCreate = (facilityId: number, parkerId: number, req: ImportPaymentReq) =>
        api2(ApiUrl.facilityParkerImportPaymentCreate(facilityId, parkerId), post(emitImportPaymentReq(req)), parsePayment);

    static paymentCreditCreate = (facilityId: number, parkerId: number, req: ImportPaymentReq) =>
        api2(ApiUrl.facilityParkerCreditCreate(facilityId, parkerId), post(emitImportPaymentReq(req)), parsePayment);

    //sub-parker management
    static subParkerInvite(facId: number, subscriptionId: number, req: SubscriptionParkerInviteReqApi) { return api<SubscriptionParkerApi>(ApiUrl.subParkerCreate(facId, subscriptionId), post(req)); }

    static subParkerBatchInvite(facId: number, subscriptionId: number, reqs: SubscriptionParkerInviteReqApi[]) {
        return api<SubscriptionParkerApi[]>(ApiUrl.subParkerBatchInvite(facId, subscriptionId), post(reqs));
    }

    static subParkerChange(facId: number, subscriptionId: number, req: SubscriptionParkerChangeReqApi) { return api<boolean>(ApiUrl.subParkerUpdate(facId, subscriptionId), post(req)); }

    static subParkerRemove(facId: number, subscriptionId: number, req: SubscriptionParkerRemoveReqApi) { return api<boolean>(ApiUrl.subParkerDelete(facId, subscriptionId), post(req)); }

    //subscription vehicle management
    static subscriptionVehicleAdd(facId: number, subscriptionId: number, req: VehicleAddReqApi) { return api2(ApiUrl.subscriptionVehicleAdd(facId, subscriptionId), post(req), parseVehicleLinkResp); }

    static subscriptionVehicleDelete(facId: number, subscriptionId: number, vehicleId: number, req: VehicleDeleteReqApi) { return api(ApiUrl.subscriptionVehicleDelete(facId, subscriptionId, vehicleId), post(req)); }

    //parker vehicles
    static vehicleAdd(facId: number, parkerId: number, req: Vehicle) { return api2(ApiUrl.vehicleCreate(facId, parkerId), post(req), parseVehicle); }
    static vehicleListByParker = (parkerId: number, facId: number) => api<Vehicle[]>(ApiUrl.vehicleListByParker(parkerId, facId), get());
    static vehicleDelete = (facId: number, parkerId: number, vehicleId: number) => api(ApiUrl.vehicleDelete(facId, parkerId, vehicleId), post({}));
    static vehicleUpdate = (facId: number, parkerId: number, vehicleId: number, req: Vehicle) => {
        return api2(
            ApiUrl.vehicleUpdate(facId, parkerId, vehicleId),
            post(req),
            parseVehicle
        );
    }

    //reports
    static facilityAgingReport(facilityId: number) { return api2(ApiUrl.facilityReportAging(facilityId), get(), arr(parseParkerAgingRecord)); }
    static paymentReports = (filter: PaymentReportFilter) => {
        const queryParams = new URLSearchParams();
        if (filter.email) queryParams.append('email', filter.email);
        if (filter.name) queryParams.append('name', filter.name);
        if (filter.from) queryParams.append('from', filter.from);
        if (filter.to) queryParams.append('to', filter.to);
        if (filter.payoutFrom) queryParams.append('payoutFrom', filter.payoutFrom);
        if (filter.payoutTo) queryParams.append('payoutTo', filter.payoutTo);
        if (filter.paymentType) queryParams.append('paymentType', filter.paymentType);
        if (filter.paymentStatus) queryParams.append('paymentStatus', filter.paymentStatus);
        if (filter.facilityId) queryParams.append('facilityId', filter.facilityId.toString());
        if (filter.facilityIds && filter.facilityIds.length > 0) {
            filter.facilityIds.forEach(id => queryParams.append('facilityIds', id.toString()));
        }
        const url = `${ApiUrl.paymentReports()}?${queryParams.toString()}`;
        return api2(url, get(), (x: unknown) => (x as PagedResult<PaymentReport>));
    };
    static payoutSummaryReports = (filter: PayoutSummaryReportFilter) => {
        const queryParams = new URLSearchParams();
        if (filter.operatorId) queryParams.append('operatorId', filter.operatorId.toString());
        if (filter.from) queryParams.append('from', filter.from);
        if (filter.to) queryParams.append('to', filter.to);
        const url = `${ApiUrl.payoutSummaryReports()}?${queryParams.toString()}`;
        return api2(url, get(), (x: unknown) => (x as PagedResult<PayoutSummaryReportApiResponse>));
    };
    static subscriptionReports = (filter: SubscriptionReportFilter) => {
        const queryParams = new URLSearchParams();
        if (filter.email) queryParams.append('email', filter.email);
        if (filter.name) queryParams.append('name', filter.name);
        if (filter.from) queryParams.append('from', filter.from);
        if (filter.to) queryParams.append('to', filter.to);
        if (filter.planName) queryParams.append('planName', filter.planName);
        if (filter.facilityId) queryParams.append('facilityId', filter.facilityId.toString());
        if (filter.status) queryParams.append('status', filter.status);
        if (filter.expireDate) queryParams.append('expireDate', filter.expireDate);
        const url = `${ApiUrl.subscriptionReports()}?${queryParams.toString()}`;
        return api2(url, get(), (x: unknown) => (x as PagedResult<SubscriptionReport>));
    };
    static agingReports = (filter: AgingReportFilter) => {
        const queryParams = new URLSearchParams();

        if (filter.email) queryParams.append('email', filter.email);
        if (filter.name) queryParams.append('name', filter.name);
        if (filter.facilityId) queryParams.append('facilityId', filter.facilityId.toString());
        if (filter.age && filter.age !== 'Any') queryParams.append('age', filter.age);
        if (filter.cutoffDate) queryParams.append('cutoffDate', filter.cutoffDate);

        const url = `${ApiUrl.agingReports()}?${queryParams.toString()}`;
        return api2(url, get(), (x: unknown) => x as PagedResult<ParkerAgingRecord>);
    };
}